<template>
	<b-modal
		v-model="viewImage"
		no-close-on-backdrop
		id="viewimage"
		centered
		hide-footer
		:title="!editImage ? 'View Image' : 'Edit Image'"
	>
		<section class="position-absolute viewimage-header-icons mr-2">
			<img
				v-if="!editImage && $route.name !== 'coursecreation'"
				@click="$emit('changeVal', 'editImage')"
				src="@/assets/common/edit.svg"
				alt=""
				class="mr-2 pointer"
			/><img
				@click="$emit('changeVal', 'delete', 'viewImage')"
				v-if="!editImage && $route.name !== 'coursecreation'"
				src="@/assets/common/delete.svg"
				alt=""
				class="mr-2 pr-2 ab-right-line pointer"
			/>
			<img
				@click="$emit('closeModal', 'viewImage')"
				class="rotate-on-hover"
				src="@/assets/common/blue-cross.svg"
				alt=""
			/>
		</section>

		<section class="p-3" v-if="!editImage">
			<div
				class="header-container mb-3"
				style="background: #eef3f7; height: unset"
			>
				<h1 class="fw-500" style="word-break: break-word">
					{{ showDetails.title }}
				</h1>
			</div>
			<span
				class="ab-lv-tags"
				v-for="(tag, index) in showDetails.tags"
				:key="index"
			>
				#{{ tag }}</span
			>
			<div class="view-image-container rounded mt-3">
				<img
					v-if="showDetails.asset"
					:src="showDetails.asset"
					alt=""
					class="overflow-hidden h-100 rounded w-100"
				/>
			</div>
		</section>
		<section v-else>
			<Files
				:fileData="showDetails"
				:editImage="editImage"
				@fileUpload="fileUpload"
				@deleteImage="deleteImage"
				:validation="validation"
				:errorFile="errorFile"
			/>
		</section>
		<hr v-if="editImage" />
		<div
			class="d-flex justify-content-end align-items-center px-3 pb-3"
			v-if="editImage"
		>
			<OButton
				class="p1-15"
				@clicked="$emit('closeModal', 'viewImage')"
				text="Cancel"
			/>
			<PButton
				:loading="loading || showLoader"
				widthClass="button-width"
				class="ml-2 p1-15"
				text="Update"
				@clicked="handleUpdateClick"
			/>
		</div>
	</b-modal>
</template>
<script>
import Files from "./Files.vue";
import { getBucket } from "../../course-creation/api-client/courseInfoAPI";
import fileUpload from "@/mixins/fileUpload";
import { postAsset } from "@/views/asset-bank/api-client/assets";
import toast from "@/mixins/toast";

export default {
	mixins: [fileUpload, toast],
	props: {
		showDetails: Object,
		editImage: Boolean,
		viewImage: Boolean,
		validation: Object,
		errorFile: Boolean,
		loading: Boolean,
	},
	components: {
		Files,
	},
	data() {
		return {
			uploadedFileData: {},
			showLoader: false,
		};
	},
	methods: {
		async handleUpdateClick() {
			if (Object.keys(this.uploadedFileData).length === 0) {
				this.$emit("handle-save");
			} else {
				await this.processFiles();
			}
		},
		async processFiles() {
			this.showLoader = true;
			let payload = {
				assetType: "3",
			};
			const response = await getBucket(payload);
			if (response.status === 200) {
				this.calculateHash(this.uploadedFileData.files, response.data.data);
			}
		},
		async saveVideoAsset(fileBucketPath) {
			try {
				let payload = {
					title: this.showDetails.title,
					assetType: String(this.showDetails.assetType),
					tags: JSON.stringify(this.showDetails.tags),
					assetLibrary: "true",
					assetID: this.showDetails.assetID,
				};

				if (this.uploadedFileData.files !== undefined) {
					payload.asset = {
						uploadType: "1",
						path: fileBucketPath,
					};
				}
				const response = await postAsset(payload, "put");
				if (response.status === 200) {
					this.showLoader = false;
					this.$emit("handle-get");
					this.$emit("closeModal", "viewImage");
					this.$nextTick(() => {
						this.successToast("Asset updated successfully!");
					});
				} else {
					this.editSpinner = false;
				}
			} catch (error) {
				this.showLoader = false;
				console.error(error);
			}
		},

		deleteImage() {
			this.$emit("changeVal", "deleteImage");
			this.uploadedFileData = {};
		},
		fileUpload(file) {
			this.uploadedFileData = file;
			this.$emit("fileUploaded", file);
		},
	},
};
</script>
